// extracted by mini-css-extract-plugin
export default {"canvas":"Confetti_canvas__OsPO7"};